import {Question2Base} from "../base/question2_base_controller";

// Connects to data-controller="questions--made-in-quebec--question2"
export default class extends Question2Base {

}
